<template>
  <div>
    <div class="evaluation-s">现场状况评估</div>
    <div class="evaluation-top" v-if="!isEmpty">
      <div v-for="row in roles"
           :key="row.key"
           v-show="dataRow[row.key].length>0"
           class="evaluation-laber"
           :class="{active:pgActive===row.key}" @click="switchRole(row.key)">
        <span :style="questionClass(row.key)"></span>{{ row.label }}
      </div>
    </div>
    <div class="evaluation-bottom" v-if="!isEmpty">
      <div class="evaluation-head">请根据视频或现场观察到的情况在5:00内作答</div>
      <div class="evaluation-ul">
        <div class="evaluation-li" v-for="question in questions" :key="question.ordinal">
          <div class="evaluation-title">{{ question.ordinal }}.{{ question.label }}</div>
          <el-radio v-for="option in question.options"
                    v-model="question.value"
                    :value="option.value"
                    :key="option.value"
                    :label="option.value"
                    :disabled="!showBtnSubmit"
          >{{ option.label }}
          </el-radio>
        </div>
      </div>
      <div class="evaluation-bt" v-if="showBtnSubmit" @click="popupQuestionConfirmDialog=true">提交</div>
    </div>
    <question-confirm-dialog v-if="popupQuestionConfirmDialog"
                             :visible="popupQuestionConfirmDialog"
                             @ok="answer"
                             @close="popupQuestionConfirmDialog=false"
    />
  </div>
</template>

<script>
import {answer} from "@/api/kecang";
import QuestionConfirmDialog from "@/views/Eventhandling/components/QuestionConfirmDialog.vue";

const ROLES = [
  {key: 'ROLE_PILOT', label: 'PILOT'},
  {key: 'ROLE_ATT', label: 'ATT'},
  {key: 'ROLE_SC', label: 'SC'},
  {key: 'ROLE_SOC', label: 'SOC'},
  {key: 'ROLE_SCDR', label: 'SC值班室'}
]
const defaultDataRow={
  ROLE_PILOT:[],
  ROLE_ATT:[],
  ROLE_SC:[],
  ROLE_SOC:[],
  ROLE_SCDR:[]
}
export default {
  components: {QuestionConfirmDialog},
  props: {
    client: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    inputEnabled: {
      type: Boolean,
      required: true
    },
    dataRow: {
      type: Object,
      required: false
    }
  },
  data() {
    const dataQuestionMap = JSON.parse(JSON.stringify(this.dataRow || defaultDataRow))
    let active = this.client
    if (dataQuestionMap[active].length === 0) {
      for (let role of ROLES) {
        if (dataQuestionMap[role.key].length > 0) {
          active = role.key
        }
      }
    }
    return {
      roles: ROLES,
      pgActive: active,
      dataQuestionMap,
      popupQuestionConfirmDialog:false
    };
  },
  watch: {
    dataRow: {
      deep: true,// true 深度监听
      handler(val, oldVal) {
        let questionMap = JSON.parse(JSON.stringify(this.dataRow || defaultDataRow))
        if (this.showBtnSubmit && this.questions.some(ele => ele.value === undefined || ele.value === null)) {
          questionMap[this.pgActive] = this.questions
        }
        this.dataQuestionMap = questionMap
      }
    }
  },
  computed: {
    isEmpty() {
      return !Object.keys(this.dataQuestionMap)
          .some(role => this.dataQuestionMap[role].length > 0)
    },
    questions() {
      return this.dataQuestionMap[this.pgActive] || []
    },
    showBtnSubmit() {
      return this.pgActive === this.client
          && this.inputEnabled
          && this.questions.length > 0
          && this.questions.some(ele => !ele.done)
    }
  },
  methods: {
    switchRole(role) {
      this.pgActive = role
    },
    questionClass(role) {
      const questionArray = this.dataQuestionMap[role];
      if (questionArray.every(ele => ele.done)) {
        return questionArray.some(ele => ele.value) ? 'background: #E07073' : 'background: #F7DD74'
      }
      return ''
    },
    async answer() {
      this.popupQuestionConfirmDialog = false
      if (this.questions.some(ele => ele.value === undefined || ele.value === null)) {
        this.$message.error('现场状况评估未完成')
        return
      }
      const answerMap = this.questions.reduce((map, {ordinal, value}) => (Object.assign(map, {[ordinal]: value})), {})
      const res = await answer({'eventId': this.id, 'type': this.type, answerMap})
      if (res.code === 'A00000') {
        this.$message.success('提交成功')
        this.questions.forEach(row => row.done = true)
      } else {
        this.$message.error('提交失败')
      }
    }
  }
};
</script>
<style lang="less">
  .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
    background: #2769EC !important;
    width: 6px;
    height: 6px;
  }
</style>
<style lang="less" scoped>
.evaluation-bottom {
  padding: 8px;
  text-align: left;
  height: calc(100% - 150px);

  .evaluation-head {
    background: rgba(235, 169, 103, 0.1);
    border-radius: 4px;
    height: 32px;
    color: #EBA967;
    font-size: 12px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }

  .evaluation-ul {
    padding: 16px;
    height: calc(100% - 120px);
    overflow: auto;

    .evaluation-li:last-child {
      margin-bottom: 0;
    }

    .evaluation-li {
      margin-bottom: 15px;

      .evaluation-title {
        color: rgba(255, 255, 255, 0.87);
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }
    }
  }

  .evaluation-bt {
    color: rgba(255, 255, 255, 0.87);
    border-radius: 8px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #2769EC;
    cursor: pointer;
    position: absolute;
    width: calc(100% - 32px);
    left: 16px;
    bottom: 16px;
  }

  .evaluation-bt.active {
    background: #393F52;
  }
}

.evaluation-s {
  color: rgba(255, 255, 255, 0.87);
  font-size: 16px;
  line-height: 16px;
  padding: 16px;
  text-align: left;
}

.evaluation-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 16px;
  border-bottom: 1px solid #0F1526;

  .evaluation-laber:nth-child(3n) {
    margin-right: 0;
  }

  .evaluation-laber {
    background: #393F52;
    border-radius: 4px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    width: calc(33.3% - 8px);
    margin-bottom: 12px;
    color: rgba(255, 255, 255, 0.87);
    font-size: 14px;

    span {
      width: 8px;
      height: 8px;
      margin-right: 4px;
      border-radius: 50%;
    }
  }

  .evaluation-laber.active {
    background: #2769EC;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/QuestionCard.vue